namespace TabAurous.Production {
    export interface MFGTransactionBOMForm {
        TransItemId: Serenity.StringEditor;
        TransId: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        BomProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        SettingId: Serenity.LookupEditor;
        StoneStatusId: Serenity.LookupEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        FromDeptId: Serenity.IntegerEditor;
        ToDeptId: Serenity.IntegerEditor;
        FromWorkerId: Serenity.IntegerEditor;
        ToWorkerId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransBomId: Serenity.StringEditor;
        CategoryId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.IntegerEditor;
        KaratId: Serenity.IntegerEditor;
        MetalColorId: Serenity.IntegerEditor;
    }

    export class MFGTransactionBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Production.MFGTransactionBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MFGTransactionBOMForm.init)  {
                MFGTransactionBOMForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = WeightEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(MFGTransactionBOMForm, [
                    'TransItemId', w0,
                    'TransId', w0,
                    'ProductId', w0,
                    'BomProductId', w0,
                    'AttributeId', w0,
                    'SettingId', w1,
                    'StoneStatusId', w1,
                    'Lab', w1,
                    'CertificateNo', w0,
                    'BagNo', w0,
                    'Line_No', w0,
                    'Pieces', w2,
                    'Weight', w3,
                    'Purity', w4,
                    'PureWeight', w3,
                    'FromDeptId', w2,
                    'ToDeptId', w2,
                    'FromWorkerId', w2,
                    'ToWorkerId', w2,
                    'RefVoucherId', w2,
                    'RefTransId', w0,
                    'RefTransItemId', w0,
                    'RefTransBomId', w0,
                    'CategoryId', w2,
                    'ProductTypeId', w2,
                    'KaratId', w2,
                    'MetalColorId', w2
                ]);
            }
        }
    }
}
